import createLucideIcon from '../createLucideIcon';

const Clock11 = createLucideIcon('Clock11', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 9.5 8', key: 'l5bg6f' }],
]);

export default Clock11;
